;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"20261104.1"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.3.6";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/assets/ff_dev_develop-20261103.7";globalThis["_sentryAssetPrefix"] = "/assets/ff_dev_develop-20261103.7";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs'

const sentryCommonInit = {
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
  beforeSend(event: Sentry.ErrorEvent) {
    if (shouldDropLoadFailedTypeError(event)) {
      return null // Drop this event
    }
    return event // Keep other events
  },
}

// Reusable function to filter out TypeError events with "Load failed" message
function shouldDropLoadFailedTypeError(event: Sentry.Event): boolean {
  return (
    event.exception?.values?.some(
      (exception) => exception.type === 'TypeError' && exception.value?.includes('Load failed')
    ) ?? false
  )
}

const sentryInitProd = {
  ...sentryCommonInit,
  // Adjust this value in production, or use tracesSampler for greater control
  // Setting to 1% initially
  tracesSampleRate: 0.01,
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  // Setting to 10% initially
  sampleRate: 0.1,
  maxBreadcrumbs: 30,
  sendClientReports: false,
  integrations: [Sentry.rewriteFramesIntegration(), Sentry.browserTracingIntegration()],
}

const sentryInitLowerEnvs = {
  ...sentryCommonInit,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  sampleRate: 1,
  maxBreadcrumbs: 50,
  sendClientReports: false,
  integrations: [Sentry.rewriteFramesIntegration(), Sentry.browserTracingIntegration()],
}

// This condition is to Check if the current site is UK as we are enabling sentry only for UK environments
const isSiteUK = process.env.NEXT_PUBLIC_SITE_KEY === 'interflora-co-uk'
// we are using NEXT_PUBLIC_BUILD_ENV instead of NODE_ENV because NEXT_PUBLIC_BUILD_ENV takes diff values for uat and prod
const sentryInit = process.env.NEXT_PUBLIC_BUILD_ENV === 'prd' ? sentryInitProd : sentryInitLowerEnvs
//we can remove this "if" check once we are ready to integrate sentry to UK prod and for all interflora-ie and flying-flowers environments
if (isSiteUK) {
  Sentry.init(sentryInit)
}
